import React from "react";

const EmailInput = ({ hasError, onChange, onFocus, value, className = "" }) => {
    return (
        <div className={`mobile-input mt-40 ${className}`}>
            <label className="text-sm color-black" htmlFor="email">
                Email Address
            </label>

            <div className={`add-amount ${hasError ? "error-field" : ""}`}>
                <input
                    className="amount-input normal-input"
                    placeholder="example@gmail.com"
                    type="email"
                    name="email"
                    id="email"
                    {...{
                        onChange,
                        onFocus,
                        value,
                    }}
                />
            </div>
        </div>
    );
};

export default EmailInput;
